import {
  onMounted,
  watch,
} from 'vue';

import { useUserStore } from '@/stores/user';

export const useAppTestograf = () => {
  const SURVEY_ID = 631097;
  const userStore = useUserStore();

  const isSurveyVisible = import.meta.env.VITE_APP_TESTOGRAF_ENABLED === 'true';

  const setSurvey = () => {
    if (isSurveyVisible && window.ttgrafSetWidgetParams) {
      window.ttgrafSetWidgetParams({ id: SURVEY_ID });
    }
  };

  const setSurveyParams = () => {
    window.testograf = {
      params: {
        e: userStore.user?.email,
        phone: userStore.user?.phone,
      },
    };
  };
  watch(() => userStore.user, setSurveyParams);

  onMounted(setSurvey);
};
